import React from 'react';

import { createIcon } from '../createIcon';

function SvgInfoCircle(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2 2h12v12H2z" />
        <path
          d="M8 2c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zm0 1.286A4.72 4.72 0 003.286 8 4.72 4.72 0 008 12.714 4.72 4.72 0 0012.714 8 4.72 4.72 0 008 3.286zm0 3.857c.355 0 .643.288.643.643v3a.643.643 0 11-1.286 0v-3c0-.355.288-.643.643-.643zm0-2.357A.643.643 0 118 6.07a.643.643 0 010-1.285z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const InfoCircleOutlinedIcon = createIcon(SvgInfoCircle, 'InfoCircleOutlinedIcon');
